import { type FC } from 'react';

import { useUserQuery } from '@/packages/query-state/shared/store/monolith-python/cian-api/site/v1/get-user-data-by-request/query';

import { CardVASListContainer } from '../../CardVASListContainer';

export const VASIconsContainer: FC = () => {
  const { data: user } = useUserQuery();

  if (user?.isAgent) {
    return <CardVASListContainer showBet={false} />;
  }

  return null;
};
